var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-layer-tile',{attrs:{"z-index":_vm.zIndex}},[_c('vl-source-xyz',{attrs:{"tile-load-function":_vm.tileLoader,"url":_vm.getZwsRequest(_vm.layer),"crossOrigin":"Anonymous"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }